import styles from "./style.module.scss";
import LinkButton from "@components/shared/form/linkButton";
import OneBuyerItem from "./oneBuyerItem";
import { useAtom } from "jotai";
import { comparisonVendors } from "@store/categoryStore";
import { translate } from "@helpers/translationObjectFormatter";
import { TranslationsObject } from "@genericTypes/sharedTypes";
import { useQuery } from "@tanstack/react-query";
import { sortArray } from "@helpers/sortArrayOfStrings";
import { removeWordFromString } from "@helpers/removeWordFromString";
import { GQLUrls } from "@gql/types/gql";
import { resolveURL } from "@lib/sharedUtils";
export default function StickyComponent({ url }: { url: GQLUrls }) {
    const { data: translations } = useQuery<TranslationsObject>([
        "translations",
    ]);
    const [comparisonList] = useAtom(comparisonVendors);
    const listToShow = comparisonList.slice(0, 5);
    const compareSlug = sortArray(
        listToShow.map((el) => removeWordFromString(el.slug as string)),
    );

    return (
        <>
            <section className={`${styles["stickyDiv"]}   `}>
                <div className="flex pt-14 justify-between items-center">
                    <h2 className=" font-bold text-3xl leading-[45px]">
                        {translate(
                            translations,
                            "several_bestOverAll_comparingWord",
                        )}
                    </h2>
                    <div className="flex gap-5">
                        {listToShow?.map((el, index) => (
                            <OneBuyerItem key={index} vendor={el} />
                        ))}
                    </div>
                    {comparisonList.length > 5 && (
                        <span className="text-xs ">{`and ${
                            comparisonList.length - 5
                        } others...`}</span>
                    )}

                    <LinkButton
                        href={`${resolveURL(url)}/comparison/${compareSlug.join(
                            "-vs-",
                        )}`}
                        className="max-w-[200px] max-h-12 font-bold"
                    >
                        {translate(
                            translations,
                            "several_general_compareButton",
                        )}
                    </LinkButton>
                </div>
            </section>
            <section className={`${styles["stickyButton"]}`}>
                <div className="">
                    <LinkButton
                        href={`${resolveURL(url)}/comparison/${compareSlug.join(
                            "-vs-",
                        )}`}
                        className="rounded-none h-[60px] flex justify-center items-center"
                    >
                        tap to compare
                    </LinkButton>
                </div>
            </section>
        </>
    );
}
